import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAnydeskComponent } from './simple-icons-anydesk.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAnydeskComponent ],
    exports:      [ SimpleIconsAnydeskComponent ],
    bootstrap:    []
})
export class SimpleIconsAnydeskModule {}
